import type { StatusMapping, WavespeedSpeechModelConfig } from './types';
import { minimaxConfigs } from './configs/minimax';
import { elevenlabsConfigs } from './configs/elevenlabs';
import { googleConfigs } from './configs/google';
import { alibabaConfigs } from './configs/alibaba';
import { bytedanceConfigs } from './configs/bytedance';
import { murekaConfigs } from './configs/mureka';

export const wavespeedStatusMapping: StatusMapping = {
  taskIdPath: 'data.urls.get',
  statePath: 'data.status',
  success: ['success', 'completed'],
  failed: ['fail', 'failed'],
  processing: ['created', 'queueing', 'processing'],
  audioUrlPath: 'data.outputs[0]',
  errorPath: 'data.error',
};

export const wavespeedModelConfigs: Record<string, WavespeedSpeechModelConfig> = {
  ...minimaxConfigs,
  ...elevenlabsConfigs,
  ...googleConfigs,
  ...alibabaConfigs,
  ...bytedanceConfigs,
  ...murekaConfigs,
};
